import { makeAutoObservable } from "mobx";
import { RSet } from "../../collections";
import { ParameterScope, ProductInstancePartScope, } from "../ParameterScope";
import { ProductInstanceHalves, } from "../ProductInstanceParts";
import { ProductConfigCreator } from "./ProductConfigCreator";
import { ProductInstanceCreatorPart } from "./ProductInstanceCreatorPart";
export class HalvesCreatorState {
    constructor(params) {
        this.isSplit = true;
        this.isSplitPossible = false;
        this.scope = ParameterScope.Uninitialized;
        this.productCategory = params.productCategory;
        this._commonConfigCreator = params.commonConfigCreator;
        this._firstHalf = params.firstHalf;
        this._secondHalf = params.secondHalf;
        makeAutoObservable(this);
    }
    static create({ productCategory, initialCommonConfig, firstHalf, secondHalf, }) {
        const commonConfigCreator = ProductConfigCreator.create({
            modifierTypes: firstHalf.productType.nonDivisibleModifierTypes.union(secondHalf.productType.nonDivisibleModifierTypes),
            customParameterTypes: firstHalf.productType.nonDivisibleCustomParameterTypes.union(secondHalf.productType.nonDivisibleCustomParameterTypes),
            initialModifierInstances: initialCommonConfig.modifierInstances,
            initialCustomParameterInstances: initialCommonConfig.customParameterInstances,
            modifierSettings: (m) => m.defaultSettings,
        });
        return new HalvesCreatorState({
            productCategory,
            commonConfigCreator,
            firstHalf: ProductInstanceCreatorPart.create(firstHalf),
            secondHalf: ProductInstanceCreatorPart.create(secondHalf),
        });
    }
    get commonConfigCreator() {
        return this._commonConfigCreator;
    }
    get firstHalf() {
        return this._firstHalf;
    }
    get secondHalf() {
        return this._secondHalf;
    }
    initWithScope(parentScope) {
        const isSplitScope = new ProductInstancePartScope({
            parentScope,
            isSplit: this.isSplit,
        });
        this.commonConfigCreator.initWithScope(isSplitScope);
        this.scope = this.commonConfigCreator.scope;
        this.firstHalf.initWithScope(this.scope);
        this.secondHalf.initWithScope(this.scope);
    }
    get productTypeIds() {
        return RSet.fromIterable([this.firstHalf.productTypeId, this.secondHalf.productTypeId], {
            ignoreDuplicates: true,
        });
    }
    get commonProductConfig() {
        return this.commonConfigCreator.productConfig;
    }
    get productInstanceParts() {
        return new ProductInstanceHalves({
            scope: this.scope,
            productCategory: this.productCategory,
            first: this.firstHalf.productInstancePart,
            second: this.secondHalf.productInstancePart,
        });
    }
    /** See {@link ProductInstanceCreator.fixAvailability} */
    fixAvailability() {
        this.commonConfigCreator.fixAvailability();
        this.firstHalf.fixAvailability();
        this.secondHalf.fixAvailability();
    }
    selectInferredDefaults() {
        this.commonConfigCreator.selectInferredDefaults();
        this.firstHalf.productConfigCreator.selectInferredDefaults();
        this.secondHalf.productConfigCreator.selectInferredDefaults();
    }
}
